export const DefaultHeaderWrapper = ({ table, ...rest }) => <thead {...rest} />;

export const DefaultHeaderRow = ({ table, headerGroup, style, ...rest }) => (
  <tr style={style} {...rest} />
);

export const DefaultHeaderCell = ({ table, header, ...rest }) => (
  <th {...rest} />
);

export const DefaultBodyWrapper = ({ table, style, ...rest }) => <tbody {...rest} style={style}/>;

export const DefaultBodyRow = ({ table, row, dataIndex, bodyRef, style, ...rest }) => <tr data-index={dataIndex} ref={bodyRef} style={style} {...rest} />;

export const DefaultBodyCell = ({ table, cell, style, ...rest }) => <td style={style} {...rest} />;

export const DefaultFooterWrapper = ({ table, style, ...rest }) => <tfoot style={style} {...rest} />;

export const DefaultFooterRow = ({ table, row, style, ...rest }) => <tr style={style} {...rest} />;

export const DefaultFooterCell = ({ table, cell, style, ...rest }) => <td style={style} {...rest} />;
